import BackFill from '@/features/backfill/components/BackFill.tsx';

export default function BackfillSoftTagPage() {
  return <BackFill />;
}
